<template>
	<div class="process">
		<div class="process-tab">
			<div
					v-if="tabData"
					v-for="(item,index) in tabData"
					:key="index"
					@click="checkTab(index,item)"
					:style="{backgroundColor:item._data?item.activeColor:item.disableColor,cursor:item._data?'pointer':'default'}"
					class="process-tab-btn"
			>
				<img
						v-if="item.srcs.length>0"
						class="right-sanjiao"
						:src="item._data?item.srcs[1]:item.srcs[0]"
						alt
				/>

				<span class="title">
          <img style="height:35px;margin-right:40px;" :src="item.icon" alt/>
          {{item.title}}
        </span>
			</div>
			<!-- <div @click="checkTab(1)" class="process-tab-btn tab2">
			  <img class="right-sanjiao" src="/steps/button_黄色三角.png" alt />
			  <span class="title">实验室</span>
			</div>
			<div @click="checkTab(2)" class="process-tab-btn tab3">
			  <img class="right-sanjiao" src="/steps/button_绿色三角.png" alt />
			  <span class="title">云平台</span>
			</div>
			<div @click="checkTab(3)" class="process-tab-btn tab4">
			  <span class="title">报告</span>
			</div>-->
		</div>
		<div class="process-steps">
			<!-- <h-step :type="0" :status="2" title="申请单录入">
			  <div v-if="false" :style="{backgroundColor:currentTab.color}" class="top-line"></div>
			  <div v-if="false" :style="{backgroundColor:currentTab.color}" class="bottom-line"></div>
			</h-step>-->
			<h-step
					v-if="isloadStep"
					v-for="item in stepsData"
					:key="item.id"
					:type="item.type"
					:status="currentStep.id>item.id?2:currentStep.id==item.id?1:0"
					:title="item.title"
			>
				<div
						v-if="currentStep.id==item.id&&currentStep.id!=12"
						:style="{backgroundColor:currentTab.color}"
						class="top-line"
				></div>
				<div
						v-if="currentStep.id==item.id&&currentStep.id!=12"
						:style="{backgroundColor:currentTab.color}"
						class="bottom-line"
				></div>
				<div v-if="item.divider" class="divider-line"></div>
			</h-step>
		</div>
		<div :style="{borderColor:currentTab.color}" class="content">
			<div v-if="flowData.length==0" class="ant-table-placeholder">暂无数据</div>
			<div v-if="flowData.length>0" style="margin:0 auto; width:860px;padding:30px 0 30px 260px;">
				<a-steps direction="vertical" size="small">
					<a-step v-for="(item,index) in flowData" :key="index">
						<span slot="icon" v-if="index == 0">
              <img src="/steps/icon_jiantou.png" alt/>
            </span>
						<span slot="icon" v-else>
              <img style="margin-left: 5px;" src="/steps/icon_yuan.png" alt/>
            </span>
						<div class="title-div" :class="{'step-2':index>0}" slot="title">
							<div class="title">{{item.operateStatusRemark||'暂无操作'}}</div>
							<div class="name">{{item.opTname||'暂无'}}</div>
							<div class="date">{{item.createTime||'暂无日期'}}</div>
						</div>
						<div slot="description">
							<div style="margin-top:10px;"
							     v-if="item.fqList&&item.operateStatus=='fq-upload-success'&&index==0">
								<div v-for="fqitem in item.fqList" :key="fqitem.id" v-if="fqitem.fileEndTime">
									{{fqitem.fileName}}
									<span v-if="currentFlowData.operateStatus=='fq-upload-success'||currentFlowData.operateStatus=='waiting'||currentFlowData.operateStatus=='cancel'||currentFlowData.operateStatus=='failed'||currentFlowData.operateStatus=='psudone'"
									      style="margin-left:20px;">
                    <span @click="deleteFqFile(fqitem)" v-auth="'10219'" class="link">删除</span>
                  </span>
								</div>
							</div>
							<div style="margin-top:10px;"
							     v-else-if="item.fqList&&item.operateStatus=='fq-to-be-uploaded'&&index==0">
								<div v-for="fqitem in item.fqList" :key="fqitem.id" v-if="fqitem.fileEndTime">
									{{fqitem.fileName}}
									<span style="margin-left:20px;">
                    <span @click="deleteFqFile(fqitem)" v-auth="'10219'" class="link">删除</span>
                  </span>
								</div>
							</div>
              <div style="margin-top:10px;"
							     v-else-if="item.fqList&&item.operateStatus=='fq-upload-failed'&&index==0||
                              item.fqList&&item.operateStatus=='fq-uploading'&&index==0">
								<div v-for="fqitem in item.fqList" :key="fqitem.id">
									{{fqitem.fileName}}
									<span style="margin-left:20px;">
                    <span @click="deleteFqFile(fqitem)" v-auth="'10219'" class="link">删除</span>
                  </span>
								</div>
							</div>
							<div style="margin-top:10px;"
							     v-else-if="item.fqList&&item.operateStatus=='fq-upload-success'">
								<div v-for="fqitem in item.fqList" :key="fqitem.id" v-if="fqitem.fileEndTime">
									{{fqitem.fileName}}
								</div>
							</div>
							<div v-if="item.reportUrl&&item.reportUrl.urlList && item.operateStatus == 'report-uploaded'">
								<div>
									{{item.reportUrl.fileName}}
									<span style="margin-left:20px;">
					                    <span @click="prewFile(item.reportUrl)" v-auth.some="['1010501','10220']"
					                          class="link">预览</span>
					                    <span class="line" v-auth.some="['1010502','10221']"></span>
					                    <span @click="downFile(item.reportUrl)" v-auth.some="['1010502','10221']"
					                          class="link">下载</span>
									</span>
								</div>
								<div style="margin-top:10px;" v-if="item.remarks"
								     v-html="remarksSplit(item.remarks)"></div>
							</div>
							<div v-else-if="item.reportUrl&&item.reportUrl.urlList && item.operateStatus != 'report-uploaded'">
								<div>
									{{item.reportUrl.fileName}}
									<span style="margin-left:20px;">
                    <span @click="prewFile(item.reportUrl)" v-auth.some="['1010509','10222']"
                          class="link">预览</span>
                    <span class="line" v-auth.some="['1010510','10223']"></span>
                    <span @click="downFile(item.reportUrl)" v-auth.some="['1010510','10223']"
                          class="link">下载</span>
									</span>
								</div>
								<div style="margin-top:10px;" v-if="item.remarks"
								     v-html="remarksSplit(item.remarks)"></div>
							</div>
							<div style="margin-top:10px;" v-else v-html="remarksSplit(item.remarks)"></div>
						</div>
					</a-step>
				</a-steps>
			</div>
		</div>
		<h-confirm
				:visible="confirmVisible"
				@close="closeConfirm"
				@ok="okClick"
				:loadding.sync="confirmLoadding"
				:title="currentConfirmData.title"
				:content="currentConfirmData.content"
				:desc="currentConfirmData.desc"
		></h-confirm>
	</div>
</template>

<script>
  import HStep from "./steps.vue";
  import axios from "axios";

  export default {
    components: {HStep},
    props: {
      bid: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        currentTab: {
          color: "#e48d27",
          disableColor: "#a4a4a4",
          activeColor: "#e48d27",
          icon: "/steps/qianchuli.png",
          srcs: ["/steps/button_灰色三角.png", "/steps/button_橘色三角.png"],
          title: "前处理"
        },
        bigTypes: [],
        confirmVisible: false,
        confirmLoadding: false,
        currentConfirmData: {
          title: "FQ文件删除",
          content: "您确认要删除上传的FQ文件吗？",
          desc: ""
        },
        currentStep: {
          id: 0,
          type: 0,
          title: "申请单录入",
          status: 2
        },
        flowData: [],
        fqList: [],
        currentFlowData: {},
        stepsData: [
          {
            id: 0,
            type: 0,
            title: "申请单录入",
            status: 2
          },
          {
            id: 1,
            type: 0,
            title: "二次确认",
            divider: true,
            status: 2
          },
          {
            id: 2,
            type: 1,
            title: "标本交接",
            status: 2
          },
          {
            id: 3,
            type: 1,
            title: "实验",
            status: 2
          },
          {
            id: 4,
            type: 1,
            title: "上机",
            status: 2
          },
          {
            id: 5,
            type: 1,
            title: "数据传输",
            divider: true,
            status: 2
          },
          {
            id: 6,
            type: 2,
            title: "等待中",
            status: 2
          },
          {
            id: 7,
            type: 2,
            title: "QC",
            status: 2
          },
          {
            id: 8,
            type: 2,
            title: "分析计算",
            status: 2
          },
          {
            id: 9,
            type: 2,
            title: "结果生成",
            divider: true,
            status: 2
          },
          {
            id: 10,
            type: 3,
            title: "结果筛选",
            status: 2
          },
          {
            id: 11,
            type: 3,
            title: "初审",
            status: 2
          },
          {
            id: 12,
            type: 3,
            title: "报告生成",
            status: 2
          }
        ],
        isloadStep: false,
        selectFqItem: null,
        tabData: [
          {
            color: "#e48d27",
            disableColor: "#a4a4a4",
            activeColor: "#e48d27",
            icon: "/steps/qianchuli.png",
            srcs: ["/steps/button_灰色三角.png", "/steps/button_橘色三角.png"],
            title: "前处理"
          },
          {
            color: "#E4DE83",
            disableColor: "#a4a4a4",
            activeColor: "#e3db5d",
            icon: "/steps/shiyanshi.png",
            srcs: ["/steps/button_灰色三角.png", "/steps/button_黄色三角.png"],
            title: "实验室"
          },
          {
            color: "#79C489",
            disableColor: "#a4a4a4",
            activeColor: "#79c489",
            icon: "/steps/yunpingtai.png",
            srcs: ["/steps/button_灰色三角.png", "/steps/button_绿色三角.png"],
            title: "云平台"
          },
          {
            color: "#3E7FFF",
            disableColor: "#a4a4a4",
            activeColor: "#3e7fff",
            icon: "/steps/baogao.png",
            srcs: [],
            title: "报告"
          }
        ]
      };
    },
    created() {
      // this.currentStep = this.stepsData[12];
      this.getBigTypes();
      this.getSmallClass();
      // this.getFqList();
    },
    mounted() {
      this.getFinshSmallClass();
    },
    methods: {
      remarksSplit(remarks) {
        let result = [];
        if (remarks) {
          if (remarks.indexOf('、') != -1) {
            let remarksSplit = remarks.split('、');
            remarksSplit.forEach((item, index) => {
              let str = '';
              if (index == (remarksSplit.length - 1)) {
                str = item;
              } else {
                str = item.substring(0, item.length - 1);
              }
              if (index == 0) {
                result.push('<div>' + str + '</div>');
              } else {
                result.push('<div>' + index + '、' + str + '</div>');
              }
            })
          } else {
            result.push('<div>' + remarks + '</div>');
          }
        }
        return result.join('');
      },
      closeConfirm() {
        this.confirmVisible = false;
      },
      checkTab(index, item) {
        if (!item._data) {
          return;
        }
        this.currentTab = this.tabData[index];
        this.getFlowData();
      },
      okClick() {
        this.$delete("uploadfq/uploadFq", {
          ids: this.selectFqItem.id
        }).then(
          res => {
            if (res.data.code == 1) {
              this.confirmLoadding = false;
              this.confirmVisible = false;
              this.$message.success("删除成功");
              this.getFlowData();
            } else {
              this.confirmVisible = false;
              this.$message.error(res.data.message);
            }
          },
          () => {
            this.confirmLoadding = false;
          }
        );
      },
      initFqList() {
      },
      deleteFqFile(item) {
        this.selectFqItem = item;
        this.confirmVisible = true;
      },
      downFile(item) {
        let uploadFile = this.$db.get("uploadFile");
        axios
          .get(
            "/api/fileupload/downloadFiles?fileUrl=" +
            uploadFile.fileHost +
            item.urlList,
            {
              responseType: "arraybuffer"
            }
          )
          .then(res => {
            var blob = new Blob([res.data]);
            this.downFileByBlob(blob, item.fileName);
          });
      },
      downFileByBlob(blob, fileName) {
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
      },
      prewFile(item) {
        let uploadFile = this.$db.get("uploadFile");
        window.open(uploadFile.fileHost + item.urlList);
      },
      getBigTypes() {
        // 根据就诊流程id获取已完成流程大类列表成功
        this.$get("base/baseInfo/findBigClassifyByPatientId", {
          patientId: this.bid
        }).then(res => {
          this.bigTypes = res.data.data;
          if (this.bigTypes) {
            this.bigTypes.forEach((item, index) => {
              this.tabData[index]._data = item;
            });
            this.currentTab = this.tabData[this.bigTypes.length - 1] ? this.tabData[this.bigTypes.length - 1] : {};
            this.getFlowData(true);
            this.initFqList();
          }
        });
      },
      getFqList() {
        this.$get("uploadfq/uploadFq/getFqList", {
          bid: this.bid
        }).then(res => {
          this.fqList = res.data.data;
        });
      },
      getFinshSmallClass() {
        this.isloadStep = false;
        this.$get("base/baseInfo/findSmallClassifyByPatientId", {
          patientId: this.bid
        }).then(res => {
          let resData = res.data.data || [];
          let smallClasss = this.setSmallClasss(resData);
          let _index = smallClasss.length == 0 ? 0 : smallClasss.length - 1;
          this.currentStep = this.stepsData[_index];
          this.isloadStep = true;
        });
      },
      // 调配满足康圣达接口返回数据不全设定逻辑编码
      setSmallClasss(data) {
        let result = [];
        if (data && data.length == 13) {
          result = data;
        } else {
          if (!this.filterStatus(data, 'sample-handover') && this.filterStatus(data, 'experiment')) {
            let pushTypeData = {
              "id": "7",
              "pid": "2",
              "baseNo": 0,
              "operateType": "sample-handover",
              "operateRemark": "标本交接",
              "baseLevel": 2,
              "isShow": 1,
              "orderNo": 30,
              "operateStatus": "sample-handover",
              "operateStatusRemark": "标本交接",
              "optUserId": "1",
              "delFlag": 0,
              "version": 0,
              "isSystem": 1
            };
            data.push(pushTypeData);
          }
          if (!this.filterStatus(data, 'up-computer') && this.filterStatus(data, 'data-transmission')) {
            let pushTypeData = {
              "id": "9",
              "pid": "2",
              "baseNo": 0,
              "operateType": "up-computer",
              "operateRemark": "上机",
              "baseLevel": 2,
              "isShow": 1,
              "orderNo": 50,
              "operateStatus": "up-computer",
              "operateStatusRemark": "上机",
              "optUserId": "1",
              "delFlag": 0,
              "version": 0,
              "isSystem": 1
            };
            data.push(pushTypeData);
          }
          result = data;
        }
        return result;
      },
      filterStatus(data, operateType) {
        let retult = 0;
        if (data) {
          data.forEach((item, index) => {
            if (item.operateType == operateType) {
              retult = 1;
              return;
            }
          });
        }
        return retult;
      },
      getSmallClass() {
        //获取流程小类列表
        this.$get("base/baseInfo/findSmallClassifyList").then(res => {
          let datas = res.data.data;
          datas.forEach((item, index) => {
            this.stepsData[index]._data = item;
          });
        });
      },
      getFlowData(status) {
        let operateStatus = this.currentTab._data ? this.currentTab._data.operateStatus : "";
        if (operateStatus == "") {
          return;
        }
        this.$get("experimentprocess/experimentProcess/histroy", {
          operateStatus: operateStatus,
          bid: this.bid
        }).then(res => {
          this.flowData = res.data.data;
          if (status) {
            if (this.flowData) {
              this.currentFlowData = this.flowData[0];
              console.log('/currentFlowData/', this.currentFlowData);
            }
          }
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
	.process {
		.line {
			height: 10px;
			width: 2px;
			margin: 0 10px;
			display: inline-block;
			background: #428ef7;
		}
		/deep/ .process-tab {
			height: 65px;
			width: 100%;
			.process-tab-btn {
				width: 25%;
				float: left;
				height: 100%;
				cursor: pointer;
				line-height: 65px;
				text-align: center;
				position: relative;
				.title {
					font-size: 24px;
					font-family: PingFang SC;
					font-weight: 400;
					color: rgba(255, 254, 254, 1);
				}
				.right-sanjiao {
					position: absolute;
					right: -18.4px;
					z-index: 10;
				}
				//   &.tab1 {
				//     background: #e48d27;
				//     position: relative;
				//   }
				//   &.tab2 {
				//     background: #e3db5d;
				//     position: relative;
				//   }
				//   &.tab3 {
				//     background: #79c489;
				//     position: relative;
				//   }
				//   &.tab4 {
				//     background: #3e7fff;
				//     position: relative;
				//   }
			}
		}
		/deep/ .content {
			height: auto;
			background: #fff;
			border: 2px solid #e4be83;
			.ant-steps-item-description {
				padding-left: 40px;
			}
			.ant-steps-item-tail {
				top: -16px !important;
				left: 10px !important;
				height: calc(100% + 40px);
			}
			.ant-steps-vertical .ant-steps-item-content {
				overflow: inherit;
				.date {
					position: absolute;
					left: -275px;
					top: 0;
				}
				.name {
					word-break: break-all;
					// overflow: hidden;
					// text-overflow: ellipsis;
					// white-space: nowrap;
					width: 80px;
					word-break: break-all;
					margin-top: -24px;
					position: absolute;
				}
			}
			.ant-steps-vertical .ant-steps-item-active .ant-steps-item-content {
				.name {
					margin-left: -110px;
				}
				.date {
					left: -280px;
				}
			}
			.step-2 {
				.name {
					left: -108px !important;
				}
				.date {
					left: -275px !important;
				}
			}
		}
		/deep/ .process-steps {
			height: 72px;
			margin: 14px 0 20px 0;
			border: 1px solid rgba(246, 247, 249, 1);
			padding: 12px 20px;
			background: #fff;
			.top-line {
				position: absolute;
				height: 14px;
				width: 2px;
				background: #e4be83;
				top: -27px;
				left: 27%;
				margin-left: 5px;
			}
			.bottom-line {
				height: 20px;
				width: 2px;
				position: absolute;
				background: #e4be83;
				bottom: -29px;
				left: 27%;
				margin-left: 5px;
			}
			.divider-line {
				width: 1px;
				height: 72px;
				background: rgba(240, 242, 245, 1);
				position: absolute;
				top: -12px;
				right: 18%;
				z-index: 9;
			}
		}
	}
</style>